/* eslint-disable react/require-default-props */
import { Button, Box } from "@mui/material"
import { useNavigate } from "react-router-dom"
import { useSelector } from "react-redux"
import { ContentContainer } from "./components/styles"

import MBankPaymentHistoryDetails from "../../components/OperationHistoryDetails/MBankPaymentHistoryDetails"
import SBPIconNoExt from "../../components/SBPIconNoExt"
import { RootState } from "../../store/store"
import { ROUTES_PATHS } from "../../utils/constants"

export const PaymentFinally = () => {
  const paymentResult = useSelector((state: RootState) => state.payment.result)
  const navigate = useNavigate()
  const isExchangeRateChanged = paymentResult?.errorDetails?.code === "exchange_rate_changed"

  const handleClickNext = () => {
    navigate(`/${ROUTES_PATHS.quit}`, {
      replace: true,
    })
  }

  const handleTryAgain = () => {
    navigate(`/${ROUTES_PATHS.topUpMbankAccountPayments}`)
  }

  const isAccepted = paymentResult?.status === "Accepted"

  return (
    <Box sx={ContentContainer}>
      <MBankPaymentHistoryDetails data={paymentResult!} />

      <Box
        mt="auto"
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          pb: "20px",
          mb: "-20px",
        }}
      >
        <SBPIconNoExt size={60} />
        <Button
          variant="contained"
          color={isAccepted ? "primary" : "secondary"}
          onClick={handleClickNext}
        >
          {isAccepted ? "Готово" : "Закрыть"}
        </Button>
        {isExchangeRateChanged && (
          <Button
            variant="contained"
            color="primary"
            onClick={handleTryAgain}
          >
            Попробовать ещё раз
          </Button>
        )}
      </Box>
    </Box>
  )
}
